package de.ohhhmhhh.frontend.admin.ui.screens.category

data class CategoryEditState(
    val renamed: String? = null,
    val uploaded: String? = null,
    val items: List<String> = emptyList(),
)
